module.exports = __webpack_public_path__ + "static/media/design-stats-animate.4d66192b.svg";